module.exports = __webpack_public_path__ + "img/videobgc1.86a3e33f.png";